import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Left Out Pratical Forms</h1>
                <p>Home &gt; Left Out Pratical Forms</p>
            </div>
        </div>
    )
}

export default Hero;